import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type TemplateDetailsForTemplateThumbnailFragment = { __typename: 'Template', legacyId: number, name?: string | null, galleryImage?: { __typename: 'DataObject', id: string } | null };

export type GetTemplateDetailsForTemplateThumbnailQueryVariables = Types.Exact<{
  legacyId: Types.Scalars['Int']['input'];
}>;


export type GetTemplateDetailsForTemplateThumbnailQuery = { __typename: 'Query', template: { __typename: 'Template', legacyId: number, name?: string | null, galleryImage?: { __typename: 'DataObject', id: string } | null } };

export const TemplateDetailsForTemplateThumbnailFragmentDoc = gql`
    fragment TemplateDetailsForTemplateThumbnail on Template {
  legacyId
  name
  galleryImage {
    id
  }
}
    `;
export const GetTemplateDetailsForTemplateThumbnailDocument = gql`
    query getTemplateDetailsForTemplateThumbnail($legacyId: Int!) {
  template(legacyId: $legacyId) {
    ...TemplateDetailsForTemplateThumbnail
  }
}
    ${TemplateDetailsForTemplateThumbnailFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTemplateDetailsForTemplateThumbnailGQL extends Apollo.Query<GetTemplateDetailsForTemplateThumbnailQuery, GetTemplateDetailsForTemplateThumbnailQueryVariables> {
    override document = GetTemplateDetailsForTemplateThumbnailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }